/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.57"
        height="79.1"
        viewBox="0 0 95.57 79.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M20.34 23.12a11.16 11.16 0 1 0 11.15 11.17 11.16 11.16 0 0 0-11.15-11.17Zm0 2.5a8.66 8.66 0 1 1-8.66 8.66 8.66 8.66 0 0 1 8.66-8.66ZM28.69 51.24a1.26 1.26 0 0 1 1.22 1.29 1.24 1.24 0 0 1-1.1 1.2H10.62a8.15 8.15 0 0 0-8.13 7.89v1.65A1.25 1.25 0 0 1 0 63.4v-1.53a10.66 10.66 0 0 1 10.34-10.63ZM75.23 23.12a11.16 11.16 0 1 0 11.15 11.17 11.16 11.16 0 0 0-11.15-11.17Zm0 2.5a8.66 8.66 0 1 1-8.66 8.66 8.66 8.66 0 0 1 8.66-8.66ZM84.98 51.24a10.63 10.63 0 0 1 10.63 10.34v1.69a1.25 1.25 0 0 1-2.49.13v-1.53a8.14 8.14 0 0 0-7.88-8.13H66.88a1.24 1.24 0 0 1-1.22-1.27 1.26 1.26 0 0 1 1.09-1.22h18.23ZM47.78 37.64a11.16 11.16 0 1 0 11.2 11.16 11.15 11.15 0 0 0-11.15-11.15Zm0 2.5a8.66 8.66 0 1 1-8.65 8.67 8.67 8.67 0 0 1 8.65-8.67ZM57.49 65.76a10.65 10.65 0 0 1 10.64 10.31v1.68a1.25 1.25 0 0 1-2.49.13v-1.52a8.14 8.14 0 0 0-7.88-8.13H38.07a8.14 8.14 0 0 0-8.13 7.88v1.64a1.252 1.252 0 1 1-2.5.13v-1.52a10.63 10.63 0 0 1 10.34-10.63Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M46.28 0v2.75l-.42.07-.43.09a6.59 6.59 0 0 0-5 4 8 8 0 0 0-.57 3.75 6.46 6.46 0 0 0 3.44 5.47 25 25 0 0 0 2.92 1.37l3.64 1.48a2.19 2.19 0 0 1 1.37 2.4 2.38 2.38 0 0 1-1.92 2.4 6.53 6.53 0 0 1-1.53.17 3.79 3.79 0 0 1-3.87-2.83c-.11-.34-.19-.68-.29-1.06l-4.6 1.19a9.49 9.49 0 0 0 2.22 4.55 7.69 7.69 0 0 0 5 2.33v3.56h3v-3.57c.6-.12 1.18-.21 1.75-.36a6.86 6.86 0 0 0 4.84-3.93 8 8 0 0 0 .55-4.79 6.34 6.34 0 0 0-3.2-4.54 35.07 35.07 0 0 0-4.4-1.92c-.9-.36-1.78-.78-2.65-1.2a2 2 0 0 1-1-1.2 2.69 2.69 0 0 1 1.78-3.35h.1a3.15 3.15 0 0 1 3.08.8 5.74 5.74 0 0 1 1.26 1.9l.3.7 4.12-1.7a8.28 8.28 0 0 0-1.52-3.11 7.29 7.29 0 0 0-5-2.6V.03Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreePeopleWithDollarSignIcon';

export default Icon;
